import type { GroupedResults } from './rows';
import { WIZARD_STEPS, type WizardStepId } from './wizard';

/**
 * Display copy for the table's four sections. `faraCorespondent` reads „Fără
 * cod final" — its predicate is "no final classification", which is NOT the
 * same as the wizard's `no_match` step ("the pipeline found no match"). Those
 * two sharing the phrase „Fără corespondent" was the 0-vs-807 contradiction
 * the 2026-08-19 remediation exists to fix. Keep them distinct.
 */
export const TABLE_BUCKET_LABELS: Record<keyof GroupedResults, string> = {
  deVerificat: 'De verificat',
  faraCorespondent: 'Fără cod final',
  rezolvate: 'Rezolvate',
  erori: 'Erori',
};

export const WIZARD_STEP_LABELS = Object.fromEntries(
  WIZARD_STEPS.map((s) => [s.id, s.label])
) as Record<WizardStepId, string>;
